<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Authentication</h2>
            <p class="operations-page__lead">
                Connect or re-authenticate this vision provider using the platform OAuth flow.
                Status below reflects the latest stored credentials.
            </p>
        </div>
    </header>

    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading authentication status…</p>
    </div>

    <div class="operations-page__card" *ngIf="connecting && !loading">
        <p class="operations-page__loading">Preparing secure provider login…</p>
    </div>

    <article class="auth-summary" *ngIf="!loading && summary" [attr.data-tone]="summary.tone">
        <div class="auth-summary__header">
            <div class="auth-summary__status">
                <span class="auth-summary__badge" [attr.data-tone]="summary.tone">{{ summary.title }}</span>
                <p class="auth-summary__detail" *ngIf="summary.detail">{{ summary.detail }}</p>
            </div>
            <div class="operations-actions">
                <button type="button"
                        class="operations-btn operations-btn--primary"
                        [disabled]="connecting || loading || !providerId"
                        (click)="startOAuth()">
                    {{ actionLabel }}
                </button>
            </div>
        </div>

        <dl class="auth-summary__meta" *ngIf="summary.lastAuthenticated || summary.tokenExpires || summary.apiEndpoint">
            <div class="auth-summary__meta-item" *ngIf="summary.lastAuthenticated">
                <dt>Last Authenticated</dt>
                <dd>{{ summary.lastAuthenticated }}</dd>
            </div>
            <div class="auth-summary__meta-item" *ngIf="summary.tokenExpires">
                <dt>Token Expires</dt>
                <dd>{{ summary.tokenExpires }}</dd>
            </div>
            <div class="auth-summary__meta-item" *ngIf="summary.apiEndpoint">
                <dt>API Endpoint</dt>
                <dd>{{ summary.apiEndpoint }}</dd>
            </div>
        </dl>
    </article>

    <app-metadata-panel
            *ngIf="!loading"
            title="Provider Authentication Details"
            [entries]="entries">
    </app-metadata-panel>
</section>
